(function () {
  'use strict';

  var TOWEL_BASE = 'https://cdn.shopify.com/s/files/1/0319/9713/2935/files/Beach_Towel_Mockup.png?v=1777552171';

  function buildMockup(canvas, designImg, towelImg) {
    var ctx = canvas.getContext('2d');
    canvas.width  = towelImg.naturalWidth  || towelImg.width;
    canvas.height = towelImg.naturalHeight || towelImg.height;

    // Tile the design across the full canvas — larger tile = bigger pattern
    var tileSize = Math.round(canvas.width / 2.2);
    var tile = document.createElement('canvas');
    tile.width  = tileSize;
    tile.height = tileSize;
    tile.getContext('2d').drawImage(designImg, 0, 0, tileSize, tileSize);

    var pattern = ctx.createPattern(tile, 'repeat');
    ctx.fillStyle = pattern;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Blend the towel on top — reduced opacity softens the terry cloth grid texture
    ctx.globalAlpha = 0.6;
    ctx.globalCompositeOperation = 'multiply';
    ctx.drawImage(towelImg, 0, 0, canvas.width, canvas.height);
    ctx.globalAlpha = 1.0;
    ctx.globalCompositeOperation = 'source-over';
  }

  function openMockup(btn) {
    var modal   = document.getElementById('ff-towel-modal');
    var canvas  = document.getElementById('ff-towel-canvas');
    var loader  = document.getElementById('ff-towel-loader');
    var designSrc = btn.dataset.design;
    if (!modal || !canvas || !designSrc) return;

    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    loader.hidden = false;
    canvas.style.display = 'none';

    var towelImg  = new Image();
    var designImg = new Image();
    var loaded = 0;

    function onLoad() {
      loaded++;
      if (loaded < 2) return;
      loader.hidden = true;
      canvas.style.display = 'block';
      buildMockup(canvas, designImg, towelImg);
    }

    towelImg.crossOrigin  = 'anonymous';
    designImg.crossOrigin = 'anonymous';
    towelImg.onload  = onLoad;
    designImg.onload = onLoad;
    towelImg.onerror = function () { loader.textContent = 'Could not load towel image.'; };
    designImg.onerror = function () { loader.textContent = 'Could not load design image.'; };
    towelImg.src  = TOWEL_BASE;
    designImg.src = designSrc;
  }

  function closeModal() {
    var modal = document.getElementById('ff-towel-modal');
    if (modal) { modal.hidden = true; document.body.style.overflow = ''; }
  }

  function initInline() {
    var inlineCanvas = document.getElementById('ff-towel-inline');
    var loader       = document.getElementById('ff-towel-inline-loader');
    var productImg   = document.getElementById('product-image');
    if (!inlineCanvas || !productImg) return;

    var towelImg  = new Image();
    var designImg = new Image();
    var loaded = 0;

    function onLoad() {
      loaded++;
      if (loaded < 2) return;
      buildMockup(inlineCanvas, designImg, towelImg);
      inlineCanvas.style.display = 'block';
      if (loader) loader.style.display = 'none';
    }

    towelImg.crossOrigin  = 'anonymous';
    designImg.crossOrigin = 'anonymous';
    towelImg.onload  = onLoad;
    designImg.onload = onLoad;
    towelImg.src  = TOWEL_BASE;
    designImg.src = productImg.src;
  }

  function init() {
    initInline();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
